import { useEffect, useMemo } from 'react';
import { useCatalogDataContext } from 'src/contexts/CatalogDataContext';

export const useAccordionItem = (viagVirtId: string) => {
  const {
    isLoading,
    isItemsLoading,
    eventsTransformed,
    eventsExpansion: { setListItemExpansion },
  } = useCatalogDataContext();

  useEffect(() => {
    if (viagVirtId) {
      setListItemExpansion(true, [viagVirtId]);
    }
  }, [setListItemExpansion, viagVirtId]);

  const accordionItemProps = useMemo(
    () =>
      eventsTransformed?.length
        ? eventsTransformed.find((ev) => ev.event.virtId === viagVirtId)
        : undefined,
    [eventsTransformed, viagVirtId]
  );

  return { isLoading, isItemsLoading, accordionItemProps };
};
